import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EModalStatus, IModalState, TModalStatus } from 'shared/types/modal';

const initialState: IModalState = {
  visible: false,
  modalStatus: { status: EModalStatus.Init },
};

/* istanbul ignore next */
const modalSlice = createSlice({
  initialState,
  name: 'modal',
  reducers: {
    setModalVisible: (state, action: PayloadAction<boolean>) => {
      state.visible = action.payload;
    },
    setModalStatus: (state, action: PayloadAction<TModalStatus>) => {
      state.modalStatus = action.payload;
    },
  },
});

export const {
  reducer: modalReducer,
  actions: { setModalVisible, setModalStatus },
} = modalSlice;
